import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import useStyles from './useStyles'
import { View } from 'react-native'
import { getRecurringTractorActiveDays } from '../../../../../tools/dataParse'
import TractorCard from './TractorCard'
import { useTheme } from '../../../../../theming/ThemeProvider'
import { Button, Card } from '../../../../../components'
import moment from 'moment'
import TractorForm from './TractorForm'

const ItineraryForm = ({ formikParams }) => {
  const { setFieldValue, values } = formikParams
  const [activeDays, setActiveDays] = useState([])
  const [inactiveDays, setInactiveDays] = useState([])
  const [currentDay, setCurrentDay] = useState()
  const [adding, setAdding] = useState(false)
  const { theme } = useTheme()
  const styles = useStyles(theme)

  useEffect(() => {
    const tractorActiveDays = getRecurringTractorActiveDays(values)
    setActiveDays(tractorActiveDays.map(day => ({
      name: day.toLowerCase(),
      label: day
    })))
    const tractorInactiveDays = moment.weekdays().filter(day => !tractorActiveDays.filter(_day => _day === day).length)
    setInactiveDays(tractorInactiveDays.map(day => ({
      name: day.toLowerCase(),
      label: day
    })))
  }, [values])

  const onSaveTractor = useCallback((newTractor, saveButtonClicked) => {
    if (currentDay && newTractor?.available && newTractor?.equipmentType) {
      setFieldValue(`tractors_available_${currentDay.name}`, newTractor.available)
      setFieldValue(`equipment_type_id_${currentDay.name}`, newTractor.equipmentType)
      setFieldValue(`teams_${currentDay.name}`, newTractor.teams)
    }
    setAdding(Boolean(saveButtonClicked))
    setCurrentDay(null)
  }, [currentDay, setFieldValue])

  return (
    <View style={styles.container}>
      {activeDays.map((day, index) => (
        <TractorCard
          key={index}
          recurringTractor={values}
          onChangeValue={setFieldValue}
          day={day}
        />
      ))}
      {adding && (
        <View>
          <Card containerStyle={styles.card} contentStyle={styles.cardContent}>
            <TractorForm
              recurringTractor={values}
              day={currentDay}
              setCurrentDay={setCurrentDay}
              daysToShow={inactiveDays}
              onSave={onSaveTractor}
            />
          </Card>
        </View>
      )}
      {Boolean(inactiveDays.length) && (
        <View style={styles.addButtonContainer}>
          <Button
            title='Add'
            onPress={() => setAdding(true)}
            style={styles.addButton}
            testID='recurringTractorsModalAddTractorButton'
          />
        </View>
      )}
    </View>
  )
}

ItineraryForm.propTypes = {
  formikParams: PropTypes.object
}

ItineraryForm.defaultProps = {
  recurringTactorToEdit: null
}

export default ItineraryForm
